import { readDepartmentBasedAssignments } from "@/schemas/departmentBasedAssignments";
import { readRoleBasedAssignments } from "@/schemas/roleBasedAssignments";
import { ReadDepartmentBasedAssignments } from "@/types/departmentBasedAssignments";
import { ReadRoleBasedAssignments } from "@/types/roleBasedAssignments";

export const createEmptyRoleBasedAssignments = (): ReadRoleBasedAssignments =>
  ({
    ...Object.fromEntries(
      Object.keys(readRoleBasedAssignments.unwrap().shape).map((key) => [
        key,
        key === "end_date" ? null : "",
      ]),
    ),
  }) as ReadRoleBasedAssignments;

export const createEmptyDepartmentBasedAssignments =
  (): ReadDepartmentBasedAssignments =>
    ({
      ...Object.fromEntries(
        Object.keys(readDepartmentBasedAssignments.unwrap().shape).map(
          (key) => [key, key === "end_date" ? null : ""],
        ),
      ),
    }) as ReadDepartmentBasedAssignments;
